/*
 *
 * ProductPriceMaster constants
 *
 */

export const DEFAULT_ACTION = 'app/ProductPriceMaster/DEFAULT_ACTION';
